<ng-content select="[drop-trigger]"></ng-content>

<div #menu class="ui-dropdown__menu {{ color }}">
    <span *ngIf="menuTitle" class="ui-dropdown__menu__title {{ color }}">{{menuTitle}}</span>
    <ng-content multiple="ui-drop-item" ></ng-content>
    <span *ngIf="!autoClose" class="ui-dropdown__close-button"><i class="la la-xs"></i></span>
</div>

